// Interfaces
import { IStyles } from '../../../resource';

// Define styles
const styles: IStyles = {
  dialog: (theme) => ({
    position: 'relative',
    backgroundColor: theme.palette.common.white,
    p: theme.spacing(98, 20),
    maxWidth: { xs: 560, md: 890 },
    width: 1,
    borderRadius: theme.spacing(30, 0),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  form: () => ({
    width: 1,
    maxWidth: 420,
  }),
  userSelect: () => ({
    '& .MuiButtonBase-root.MuiIconButton-root': {
      height: 24,
      width: 24,
      marginLeft: 8,
      border: 0,
      boxShadow: 'none'
    }
  }),
};

// Export styles
export default styles;
